/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903263793 — useAppStore + useTimerStore */

import { create } from 'zustand';

import { TIMER_START_VALUE } from '../constants';

interface TimerState {
    time: number;
    isVisible: boolean;
    setTime: (t: number) => void;
    setVisible: (v: boolean) => void;
}

export const useTimerStore = create<TimerState>((set) => ({
    time: TIMER_START_VALUE,
    isVisible: false,
    setTime: (t) => set({ time: t }),
    setVisible: (v) => set({ isVisible: v }),
}));
